import { render, staticRenderFns } from "./Terminals.vue?vue&type=template&id=424cb74a"
import script from "./Terminals.vue?vue&type=script&lang=js"
export * from "./Terminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports